// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_Kkn","cls2":"PaperBrowserPreviewList-cls2_8RU PaperBrowserPreviewList-cls1_Kkn"};